function decodeHtml(html) {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}
window.handleAddonRemovalIfRequired = async function (removeBtn) {
  const item = removeBtn.closest('.cart-item');
  const loading__spinner = item.querySelector('.loading__spinner');
  if (loading__spinner) {
    loading__spinner.classList.remove('hidden');
  }
  const cartItemTitle = item?.querySelector('.cart-item__name')?.innerText || '';
  const productOptions = item?.querySelectorAll('.product-option dt') || [];

  let isAddonProduct = false;
  let allAddon = '';
  const prodDeliveryDate = item.querySelector('.item_delivery_date').innerHTML;
  for (const option of productOptions) {
    const text = option.innerText.trim();
    if (text === 'Add Ons:') {
      isAddonProduct = true;
      allAddon = option.nextElementSibling.innerText.trim();
    } else if (text === 'Addon Of:') {
      await window.handleAddonRemoval(item);
      return;
    }
  }
  if (isAddonProduct) {
    await window.handleAddonRemovalOnProductDelete(cartItemTitle, allAddon, prodDeliveryDate);
  }
};
window.handleAddonRemovalOnProductDelete = async function (title, allAddon, prodDeliveryDate) {
  try {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`);
    const cart = await response.json();
    const addonItems = cart.items.filter(item => {
      const addonOf = item.properties?.['Addon Of'];
      const addonDate = item.properties?.['Delivery Date'];
      return addonOf?.trim() === title.trim() &&
       allAddon.includes(decodeHtml(item.title)) &&
       prodDeliveryDate.trim() == addonDate.trim();
    });
    for (let addon of addonItems) {
      const newQuantity = addon.quantity > 1 ? addon.quantity - 1 : 0;
      await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: addon.key,
          quantity: newQuantity
        })
      });
    }
  } catch (error) {
    console.error('Error removing addon items:', error);
  }
};
window.handleAddonRemoval = async function (addonItem) {
  const addOnTitle = addonItem?.querySelector('.cart-item__name')?.innerText?.trim();
  const addonDeliveryDate = addonItem?.querySelector('.item_delivery_date')?.innerHTML?.trim();
  if (!addOnTitle || !addonDeliveryDate) return;
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    const matchingProducts = cart.items.filter(item => {
      const itemDeliveryDate = item.properties?.['Delivery Date']?.trim();
      return item.properties?.['Add Ons']?.includes(addOnTitle) && itemDeliveryDate === addonDeliveryDate;
    });
    if (matchingProducts.length === 0) return;
    for (const originalProduct of matchingProducts) {
    const currentAddOns = originalProduct.properties['Add Ons']
      .split(',').map(str => str.trim());
    const updatedAddOns = currentAddOns.filter(title => !title.includes(addOnTitle));

    // Update the original product line item
    const updatedProperties = { ...originalProduct.properties };
    if (updatedAddOns.length === 0) {
      delete updatedProperties['Add Ons'];
    } else {
      updatedProperties['Add Ons'] = updatedAddOns.join(', ');
    }
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: originalProduct.key,
        quantity: originalProduct.quantity,
        properties: updatedProperties
      })
    });
  }
  } catch (err) {
    console.error('Error updating add-on from original product:', err);
  }
};